import { axiosInstance } from '../api';

export default function(userId) {
    return axiosInstance.get(`/api/users/${userId}/profile`);
}